var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTechTalkEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "0 0 161 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80.3687,
    cy: 80.376,
    r: 80,
    fill: "#E9ECEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3885_12690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.1789 45.252C78.6286 46.8435 72.7623 52.7653 71.1894 60.4082C70.6712 62.9249 70.7452 66.7001 71.3744 69.0133C72.9104 74.676 76.7225 79.2284 81.9967 81.7082C82.8479 82.0968 83.6437 82.4299 83.7547 82.4299C83.9027 82.4299 83.9583 83.8548 83.9583 87.2044C83.9583 92.2749 83.9768 92.4415 84.865 92.7005C85.2352 92.8116 85.8458 92.2749 89.9541 88.2037L94.599 83.5587L102.649 83.5032C110.643 83.4292 110.717 83.4292 112.475 82.9481C121.488 80.5053 127.465 72.4183 127.021 63.2765C126.78 58.6131 124.985 54.3383 121.802 50.9888C118.823 47.8428 115.177 45.8627 111.051 45.141C109.737 44.9189 107.516 44.8634 98.6888 44.8819C88.6957 44.8819 87.8074 44.9189 86.1789 45.252Z",
    fill: "#B2B2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5612 58.1875C40.8401 58.5391 39.2301 59.7975 38.4159 61.4445L37.9717 62.3513L37.8792 83.7253L37.7867 105.099L35.0293 105.155L32.2905 105.21L32.3645 107.931C32.42 110.373 32.4756 110.762 32.9012 111.669C33.1603 112.224 33.6229 112.964 33.919 113.316C34.5667 114.093 36.0472 115.037 37.065 115.333C37.6386 115.5 46.6879 115.555 74.3539 115.555H110.884L111.92 115.129C113.234 114.574 114.197 113.853 114.881 112.835C115.807 111.484 116.01 110.688 116.121 107.82L116.214 105.192H113.401H110.606V96.7533V88.2962L108.904 88.4257C107.979 88.4813 106.184 88.5368 104.944 88.5368H102.649L102.612 96.8088L102.557 105.099L92.3414 105.155L82.1263 105.192L81.9967 105.858C81.8487 106.654 81.0344 107.505 80.2387 107.672C79.1469 107.894 68.5616 107.783 67.8584 107.542C67.1552 107.302 66.3779 106.302 66.3779 105.636V105.192H56.1073H45.8367V85.6684V66.1449H55.7927H65.7673L65.8783 63.5911C65.9523 62.2032 66.1374 60.5192 66.2854 59.853C66.4335 59.1868 66.5445 58.5021 66.563 58.317C66.563 58.0209 65.8968 58.0024 54.9599 58.0209C48.557 58.0394 42.9868 58.1135 42.5612 58.1875Z",
    fill: "#B2B2B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3885_12690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.749,
    height: 94.749,
    fill: "white",
    transform: "translate(32.3275 32.8347)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechTalkEmptyState);
export default __webpack_public_path__ + "static/media/TechTalkEmptyState.6887cf01aae64101a03808b4e0224af3.svg";
export { ForwardRef as ReactComponent };